import { usePWA } from "@/hooks/use-pwa";

const ANDROID_STORE_URL = import.meta.env.VITE_ANDROID_STORE_URL;
const IOS_STORE_URL = import.meta.env.VITE_IOS_STORE_URL;

/**
 * 마이그레이션 안내 화면
 * PWA 비활성화 후 네이티브 앱으로 유도
 */
export function MigrationPrompt() {
  const { isIOS } = usePWA();

  const storeUrl = isIOS ? IOS_STORE_URL : ANDROID_STORE_URL;
  const storeName = isIOS ? "App Store" : "Play Store";
  const hasStoreUrl = !!storeUrl;

  const handleStoreClick = () => {
    if (storeUrl) {
      window.location.href = storeUrl;
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white px-6">
      {/* 앱 아이콘 */}
      <div className="mb-6">
        <img
          src="/icons/icon-192x192.png"
          alt="그로잉어학원"
          width={120}
          height={120}
          className="rounded-3xl shadow-lg"
          loading="lazy"
        />
      </div>

      {/* 타이틀 */}
      <h1 className="mb-2 text-2xl font-bold text-gray-900">그로잉어학원</h1>
      <p className="mb-2 text-center text-gray-600">
        새로운 앱이 출시되었습니다!
      </p>
      <p className="mb-8 text-center text-sm text-gray-500">
        더 나은 학습 경험을 위해 앱을 설치해주세요
      </p>

      {/* 스토어 버튼 */}
      {hasStoreUrl ? (
        <button
          onClick={handleStoreClick}
          className="mb-4 w-full max-w-sm rounded-xl bg-blue-500 px-6 py-4 text-lg font-semibold text-white shadow-lg transition-colors hover:bg-blue-600 active:bg-blue-700"
        >
          {storeName}에서 다운로드
        </button>
      ) : (
        <div className="w-full max-w-sm rounded-2xl bg-gray-50 p-6 text-center">
          <p className="text-gray-600">
            앱이 곧 출시될 예정입니다.
            <br />
            조금만 기다려주세요!
          </p>
        </div>
      )}

      {/* 안내 문구 */}
      <p className="mt-4 text-center text-xs text-gray-400">
        기존 PWA를 삭제하고 새 앱을 설치해주세요
      </p>
    </div>
  );
}
